<template>
  <div class="view-mode">
    <FormSubscriptionPeriod
      :showing.sync="createModal"
      :original-tasks="taskApplicability"
      has-end-action
      @refresh="refreshData"
      @close="closeFormModal"
    />

    <AgGrid
      v-if="metadataColumns"
      ref="agGrid"
      :header-height="48"
      :options="gridOptions"
      :api-request="infiniteScrollRequest"
      class="q-px-sm"
      style="grid-template-rows: 1fr"
      @filter-changed="filterInProgress = true"
      @new-rows-loaded="filterInProgress = false"
      @ready="onGridReady"
      @export-loading="exportLoading = $event"
    />
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
// Mixins
import gridOptions from './gridOptions'
import { exportToExcel } from '@/mixins/export-to-excel'
// Libraries
import { mapState, mapGetters } from 'vuex'
// Components
import AgGrid from '@/ag-grid/AgGrid'
import FormSubscriptionPeriod from '@components/forms/form-subscription-period/FormSubscriptionPeriod'

export default {
  components: {
    AgGrid,
    FormSubscriptionPeriod
  },

  mixins: [gridOptions, exportToExcel],

  data() {
    return {
      agGrid: null,
      createModal: false
    }
  },

  computed: {
    ...mapState('lv-subscriptions', ['metadataColumns', 'tableState', 'editMode']),
    ...mapGetters('subscriptions/subscriptionPeriods', ['taskApplicability']),
    ...mapGetters('entity-labels', ['departmentLabel']),

    filterInProgress: {
      get() {
        return this.$store.state['lv-subscriptions'].filterInProgress
      },
      set(newVal) {
        this.$store.commit('lv-subscriptions/setFilterInProgress', newVal)
      }
    },

    exportLoading: {
      get() {
        return this.$store.state['lv-subscriptions'].exportLoading
      },

      set(newVal) {
        this.$store.commit('lv-subscriptions/setExportLoading', newVal)
      }
    }
  },

  watch: {
    'tableState.chipFilter': 'refreshData'
  },

  created() {
    this.$store.commit('lv-subscriptions/setEditMode', false)
  },

  methods: {
    openCreateModal() {
      // access from parent
      this.createModal = true
    },

    onGridReady(agGrid) {
      this.$emit('ag-grid', agGrid)
      this.agGrid = agGrid
      this.tableState.filter && this.agGrid.api.setFilterModel(this.tableState.filter)
      this.tableState.columns && this.agGrid.columnApi.setColumnState(this.tableState.columns)
    },

    infiniteScrollRequest(request) {
      return apiTo.GET_PAGINATED_SUBSCRIPTIONS(request, this.tableState.chipFilter)
    },

    refreshData() {
      this.agGrid && this.$refs.agGrid.purgeServerSideCache()
    },

    closeFormModal(created) {
      this.createModal = false
      if (created) this.refreshData()
    },

    exportToExcel() {
      this.mixinExportToExcel(this.agGrid, this.tableState.chipFilter, 'subscriptions')
    }
  }
}
</script>
